import { NgModule } from '@angular/core';
import { StrongPasswordMessageDirective } from './directives/strong-password-message.directive';

@NgModule({
  declarations: [StrongPasswordMessageDirective],
  exports: [StrongPasswordMessageDirective]
})
export class FormShareModule {}
